import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { useQuery } from '../hooks/useQuery';

import Box from '@mui/material/Box';

import PagamentoItem from './PagamentoItem';

const RowPagamentoDiretoDetails = ({ pagamento }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [statuses, setStatuses] = React.useState([]);
  const { obterHistoricoStatusPagamentoDireto, getStatusFluig } = useQuery();

  React.useEffect(() => {
    obterHistoricoStatus();
  }, []);

  const obterHistoricoStatus = (e) => {
    setIsLoading(true);
    if (
      pagamento.tipo_documento == 'fundoFixo' ||
      pagamento.tipo_documento == 'cancelaVendaDevolucao'
    ) {
      getStatusFluig(pagamento.numero_processo_fluig)
        .then(({ data }) => {
          setStatuses(data);
          setIsLoading(false);
        })
        .catch((e) => setIsLoading(false));
    } else {
      obterHistoricoStatusPagamentoDireto(pagamento.id)
        .then(({ data }) => {
          let find = false;
          let dataModify = [];
          data.forEach((element, index) => {
            if (element.desc_movto == 'AGUARDANDO PAGAMENTO') {
              if (!find) {
                dataModify.push(element);
              }
              find = true;
            } else {
              dataModify.push(element);
            }
          });
          setStatuses(dataModify);
          if (data && data.length > 0) {
            console.log('open', data);
            pagamento.status =
              pagamento.situacao_nf == 'CANCELADO'
                ? 'CANCELADO'
                : data[0].desc_movto;
            // enviarPagamentoDireto(pagamento);
          }

          setIsLoading(false);
        })
        .catch((e) => setIsLoading(false));
    }
  };

  return (
    <tr>
      <td colSpan={8}>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
          </Box>
        ) : (
          <PagamentoItem pagamento={pagamento} statuses={statuses} />
        )}
      </td>
    </tr>
  );
};

export default RowPagamentoDiretoDetails;
